import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pointer-events-none fixed right-4 top-4 z-[9999] flex w-[320px] max-w-[calc(100vw-2rem)] flex-col gap-2" }
const _hoisted_2 = { class: "flex items-start justify-between gap-2" }
const _hoisted_3 = { class: "leading-5" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
      return (_openBlock(), _createElementBlock("div", {
        key: toast.id,
        class: _normalizeClass(["pointer-events-auto rounded-lg border px-3 py-2 text-sm font-medium shadow-lg", _ctx.toastClass(toast.type)])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(toast.message), 1),
          _createElementVNode("button", {
            class: "text-xs opacity-75 hover:opacity-100",
            type: "button",
            onClick: ($event: any) => (_ctx.removeToast(toast.id))
          }, " ✕ ", 8, _hoisted_4)
        ])
      ], 2))
    }), 128))
  ]))
}